import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=4d82b820&"
import script from "./LandingLayout.vue?vue&type=script&lang=js&"
export * from "./LandingLayout.vue?vue&type=script&lang=js&"
import style0 from "./LandingLayout.vue?vue&type=style&index=0&id=4d82b820&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d82b820')) {
      api.createRecord('4d82b820', component.options)
    } else {
      api.reload('4d82b820', component.options)
    }
    module.hot.accept("./LandingLayout.vue?vue&type=template&id=4d82b820&", function () {
      api.rerender('4d82b820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/LandingLayout.vue"
export default component.exports